export const TOTP = 'TOTP';
export const MFA_METHODS = [
    {
        name:'Authenticator apps',
        info:'Use an authentication app to get two-factor authentication codes when prompted.',
        desc:"Get a verification code from an authenticator app you have configured.",
        installation:{key:'totpSetup',title:'Configure app'},
        value:TOTP
    },
    {
        name:'One-time code via Email',
        info:'Get one-time codes sent to your registered email to get two-factor authentication codes when prompted.',
        desc:"Get a verification code sent to your email.",
        value:'SMS'
    }
]
export const DEFAULT_PREF = 'NOT_PREFERRED';
export const MFA_PREF = [...MFA_METHODS,{name:"Select during signing in",value:DEFAULT_PREF}];